import { render, staticRenderFns } from "./AdditionalCategory.vue?vue&type=template&id=2b04e7c7&"
import script from "./AdditionalCategory.vue?vue&type=script&lang=js&"
export * from "./AdditionalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports